<template>
  <section>
    <b-row class="">
      <b-col md="12" v-if="group_match">
        <b
          ><p id="tailieTitleText">{{ $t("match-multiple-main-title") }}:</p></b
        >
      </b-col>
      <b-col v-else class="text-left">
        <h4 class="font-weight-bold">
          {{ $t("match-full-fit-hello") }} {{ name }},
        </h4>
        <h4 class="font-weight-bold">
          {{ $t("match-full-fit-your-perfect-size-is") }}:
        </h4>
      </b-col>
    </b-row>
    <transition name="zoom" :duration="2500" @after-enter="showContent = true">
      <b-row v-if="showAnim" class="mt-5">
        <b-col md="12">
          <b-card class="bg-light-gray border-0 ">
            <b-card-body class="overflow-auto" style="max-height:150px;">
              <div v-for="match in matchResult" :key="match">
                <b-row
                  v-bind:class="{
                    matchResult: match.STATUS !== 'FULL FIT'
                  }"
                  class="text-center"
                >
                  <b-col md="12"
                    ><b>{{ match.SIZE }}</b></b-col
                  >
                  <b-col md="12"> {{ match.PRODUCTID }} </b-col>
                </b-row>
              </div>
            </b-card-body>
            <b-card-footer class="bg-light-gray border-0">
              <b-button
                @click="addProduct"
                variant="black"
                class="rounded px-1"
                :disabled="!this.matchResult.length"
              >
                <Cart />
                {{ $t("add-to-cart") }}
              </b-button>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Cart from "../../assets/images/cart.svg";

require("vue2-animate/dist/vue2-animate.min.css");

export default {
  name: "pages-product-multiple-match",
  components: {
    Cart
  },
  mounted() {
    this.showAnim = true;
  },
  data() {
    return {
      showAnim: false,
      showContent: false,
      groupSizes: []
    };
  },
  watch: {
    group_match: function() {
      for (let i = 0; i < this.group_match.results.length; i++) {
        let groupUser = this.group_match.results[i];
        if (groupUser.result.SIZE) {
          this.groupSizes.push(groupUser.result.SIZE);
        }
      }
    }
  },
  created() {
    this.$store.commit(
      "ui/SET_POST_LOADING_TEXT",
      this.$t("match-loading-size-found")
    );
    this.$store.commit("ui/SET_POST_LOADING_ANIMATION_SIZE_FOUND");
    this.$store.commit(
      "ui/SET_LOADING_TEXT",
      this.$t("match-loading-checking-passports")
    );
    this.$store.commit("ui/SET_LOADING", true);
    this.$store
      .dispatch("users/matchUser")
      .then(() => this.$store.commit("ui/SET_LOADING", false))
      .catch(() => this.$store.commit("ui/SET_LOADING", false));
  },
  methods: {
    addProduct() {
      this.$store.dispatch("application/addCartLog", {
        root: true
      });
      let groupedItems = [];
      for (let i = 0; i < this.groupSizes.length; i++) {
        let size = this.groupSizes[i];
        let item = groupedItems.find(
          groupedItems => groupedItems.size === size
        );
        if (item) {
          //add 1 to qty
          item.quantity += 1;
        } else {
          //create new object and push to array
          let variant = this.productCombinations.find(
            c => c.size.toLowerCase() === size.toLowerCase()
          );
          groupedItems.push({ size: size, quantity: 1, variant: variant.id });
        }
      }
      this.$store.dispatch("opener/postMessage", {
        event: "addProduct",
        message: {
          size: groupedItems
        }
      });
      this.$gtag.event("add_to_cart", {
        method: "Google",
        event_callback: function() {
          this.$store.dispatch("application/close");
        }
      });
    }
  },
  computed: {
    ...mapGetters({
      name: "users/getSelfFirstName",
      matchResult: "users/getSelfMatch",
      last_updated_at: "users/getSelfLastUpdated",
      contacts: "contacts/getContacts"
    }),
    matchStatus() {
      if (
        this.matchResult === "FULL FIT" &&
        !this.productCombinations.find(
          c => c.size.toLowerCase() === this.matchSize.toLowerCase()
        )
      ) {
        return "NO FIT";
      }
      return this.matchResult;
    }
  }
};
</script>
<style>
.groupResultCard {
  background-color: #f3f5f8;
  border-color: #f3f5f8;
  height: 200px;
}

.resultText {
  margin-top: 10px;
}

.groupCart {
  background-color: #f3f5f8;
}

#tailie-size .tailie-size-check.show {
  z-index: 9999999;
  right: 5px;
}

.matchResult {
  color: gray;
}

.tailie-add-to-cart {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
}
</style>
